import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const updateSkillMap = api(async function updateSkillMap({ id, data }) {
    return mutate(
        gql`
            mutation UpdateSkillMap($id: String!, $data: SkillMapInput!) {
                updateSkillMap(id: $id, data: $data)
            }
        `,
        { id, data },
        { returns: "updateSkillMap" }
    )
})
